module.exports = __webpack_public_path__ + "img/ticket.7b660428.png";